module.exports = __webpack_public_path__ + "img/armor_helmet.143dab58.svg";